import type { PlanSubscriptionType } from '@jusbrasil-web/shared-apollo-client/types'

import { TopbarContextType } from '../../../types'
import { TopbarUserMenuItemKey } from './items'

// Plans where the user already subscribes to a lawsuit-related bundle.
// These users are blocked from accessing the Annual Plans LP, so we
// shouldn't show that CTA in the menu.
const LAWSUIT_PLAN_SUBSCRIPTIONS = new Set<PlanSubscriptionType>([
  'LawsuitPlan' as PlanSubscriptionType,
  'LawsuitAndBgCheckPlan' as PlanSubscriptionType,
])

export function mountItems(ctx: TopbarContextType): TopbarUserMenuItemKey[] {
  const { user, takeover } = ctx
  const items: TopbarUserMenuItemKey[] = []

  if (user) {
    if (takeover) items.push('TAKEOVER', 'SEPARATOR')

    if (user.profiles.length) items.push('PROFILE_SWITCH', 'SEPARATOR')

    const isLawsuitSubscriber =
      !!user.planSubscriptionType && LAWSUIT_PLAN_SUBSCRIPTIONS.has(user.planSubscriptionType)

    const shouldShowAnnualPlansLink =
      user.hasAccessToSomeBundle &&
      !user.boxProfileInfo?.linkedAccount &&
      !isLawsuitSubscriber &&
      !user.hasYearlyPlan

    if (!user.hasAccessToSomeBundle) items.push('pro', 'SEPARATOR')
    else if (shouldShowAnnualPlansLink) items.push('annual-plans', 'SEPARATOR')

    items.push('jusbrasilia')

    if (user.isB2BSelfService) items.push('manage-users', 'buy-seats')

    items.push('search', 'lawsuits', 'my-documents')

    items.push('settings', 'SEPARATOR')
  }

  if (user && user.hasAccessToSomeBundle && user.isLawyer) items.push('online-office', 'SEPARATOR')

  if (!user) items.push('lawyers', 'SEPARATOR')

  items.push('help', 'about')

  if (user) items.push('logout')

  return items
}
